<template>
    <v-container grid-list-sm text-xs-left>
        <v-layout row wrap pa-2>
            <v-flex xs12>
                <v-layout align-center justify-left>
                    <div class="headline">Documentation</div>
                </v-layout>
            </v-flex>
            <v-layout row wrap justify-left py-4>
                <v-flex xs12
                        sm6
                        md6
                        lg4
                        class="px-2 pb-2">
                    <v-card class="rounded">
                        <v-layout>
                            <v-flex shrink>
                                <v-img :aspect-ratio="1"
                                        class="rounded-top-left"
                                        :src="require('@/assets/img/tutorial/userManual.jpg')"
                                        height="125px"
                                       width="125px"
                                ></v-img>
                            </v-flex>
                            <v-flex xs12>
                                <v-card-title primary-title>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <div class="headline">
                                                User Manual
                                            </div>
                                        </v-flex>
                                        <v-flex xs12>
                                            <div>Manual to be consulted for correct use of IVE</div>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions class="pa-2">
                            <v-spacer></v-spacer>
                            <v-btn
                                    flat
                                    href="docs/UserManual.pdf"
                                    download
                            >
                                Download
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex xs12
                        sm6
                        md6
                        lg4
                        class="px-2 pb-2">
                    <v-card class="rounded">
                        <v-layout >
                            <v-flex shrink>
                                <v-img :aspect-ratio="1"
                                        class="rounded-top-left"
                                        :src="require('@/assets/img/tutorial/swaggerAPI.jpg')"
                                        height="125px"
                                       width="125px"
                                ></v-img>
                            </v-flex>
                            <v-flex xs12>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="headline">
                                            Swagger API
                                        </div>
                                        <div>See Swagger API documentation.</div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions class="pa-2">
                            <v-spacer></v-spacer>
                            <v-btn flat @click="navigate()">
                                Open page
                                <v-icon>mdi-application-export</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
    import RouterService from "@/helpers/RouterService";

    export default {
        name: "TutorialHome",
        components: {},
        data() {
            return {
                videos: [
                    {
                        id: "ZXyduzS1RVw",
                        name: "Presenting IVE",
                        description: "Intelligent Virtual Entity, a brief presentation with an overview of all the functionalities.",
                        url: "https://youtu.be/ZXyduzS1RVw",
                    }
                ],
            };
        },
        methods: {
            playVideo(video) {
                this.$refs[video.id].player.playVideo();
            },
            playing(video) {

            },
            navigate() {
                RouterService.goTo("/tutorial/api");
            }
        },
    };
</script>

<style lang="scss">

</style>
